import { SoundIcon } from 'src/themes/cosmos/icons';

import SoundHeightIndicator from '../SoundHeightIndicator';
import SoundMuteIndicator from '../SoundMuteIndicator';
import styles from './styles.module.scss';

interface ISoundIndicatorProps {
  volume: number;
}

const SoundIndicator = ({ volume }: ISoundIndicatorProps) => (
  <>
    <SoundIcon className={styles.soundIcon} />
    <div className={styles.soundIndicatorsContainer}>
      <SoundHeightIndicator volume={volume} />
      <SoundMuteIndicator volume={volume} />
    </div>
  </>
);

export default SoundIndicator;
